/**
 * Customized-assessment drafts (ApiWeb.AssessmentDraftController). Binary CRDT
 * payloads travel as base64 strings.
 */

import { request } from 'js/api/axios';

const auth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

const draftsPath = (workspaceId, suffix = '') =>
  `/api/workspaces/${workspaceId}/assessment-drafts${suffix}`;

const data = (response) => response.data.data;

export function listDrafts(token, workspaceId, { teamId, sourceKey }) {
  return request
    .get(draftsPath(workspaceId), {
      ...auth(token),
      params: { team_id: teamId, source_key: sourceKey },
    })
    .then(data);
}

export function getDraft(token, workspaceId, draftId) {
  return request
    .get(draftsPath(workspaceId, `/${draftId}`), auth(token))
    .then(data);
}

export function createDraft(token, workspaceId, draft) {
  return request
    .post(draftsPath(workspaceId), { assessment_draft: draft }, auth(token))
    .then(data);
}

export function deleteDraft(token, workspaceId, draftId) {
  return request.delete(draftsPath(workspaceId, `/${draftId}`), auth(token));
}

/** The draft converted the way a published template is. */
export function getDraftAssessment(token, workspaceId, draftId) {
  return request
    .get(draftsPath(workspaceId, `/${draftId}/assessment`), auth(token))
    .then(data);
}

export function mergeDraft(token, workspaceId, draftId, { update, revision }) {
  return request
    .post(
      draftsPath(workspaceId, `/${draftId}/merge`),
      { update, revision },
      auth(token)
    )
    .then(data);
}

export function promoteDraft(
  token,
  workspaceId,
  draftId,
  { template, revision }
) {
  return request
    .post(
      draftsPath(workspaceId, `/${draftId}/promote`),
      { template, revision },
      auth(token)
    )
    .then(data);
}

/**
 * A workspace template's live document (`update`, base64), for forking a draft
 * from it, and whether it has changes since the last publish that teams
 * would see (`has_unpublished_changes`).
 */
export function getTemplateState(token, workspaceId, templateId) {
  return request
    .get(
      `/api/workspaces/${workspaceId}/assessment-doc-templates/${templateId}/state`,
      auth(token)
    )
    .then(data);
}
